// @vue/component
import ShPopConfirm from '@/components/Helpers/ShPopConfirm';
import ShTextWrapperVertical from '@/components/Helpers/ShTextWrapperVertical';


export default {
  name: 'ReportsListItem',

  components: {
    ShPopConfirm,
    ShTextWrapperVertical,
  },

  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    handleShowFormExportReport() {
      this.$emit('handleShowFormExportReport');
    },
  },
};
